import MediaKitIntro from "./MediaKitIntro";
import type { MediaKitPage } from "@/config/mediakitConfig";

const MEDIAKIT_DESKTOP_PAGES: MediaKitPage[] = [
  {
    id: 1,
    image: "https://res.cloudinary.com/nm-creators/image/upload/v1773949146/page_one_zlay64.png",
    imageMobile: "https://res.cloudinary.com/nm-creators/image/upload/v1773950136/page_one_mobile_wvuawv.png",
    alt: "MediaKit Desktop - Portada / Página 1",
    title: "Portada",
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/nm-creators/image/upload/v1773949145/page_two_md0bwm.png",
    imageMobile: "https://res.cloudinary.com/nm-creators/image/upload/v1773950135/page_two_mobile_hi9ddc.png",
    alt: "MediaKit Desktop - Página 2",
    title: "Página 2",
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/nm-creators/image/upload/v1773949146/page_three_i9sb14.png",
    imageMobile: "https://res.cloudinary.com/nm-creators/image/upload/v1773950141/page_three_mobile_lrpazs.png",
    alt: "MediaKit Desktop - Página 3",
    title: "Página 3",
  },
];

const MediaKitDesktop = () => {
  return (
    <MediaKitIntro
      pages={MEDIAKIT_DESKTOP_PAGES}
      startFullscreen
      enableDownload={false}
      enableThumbnails={false}
    />
  );
};

export default MediaKitDesktop;
